import { ShareAltOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, message } from "antd";
import { SvgIcons } from "Icon/SvgIcons";
import React from "react";
import LimitedAccessForm from "./LimitedAccessForm";

const LimitedAccessModal = ({ isModalOpen, hideModal, selectedPool, hideCheckboxes, report_id }: any) => {
  const handleCopyDomain = () => {
    const domain = window.location.origin;
    navigator.clipboard
      .writeText(domain)
      .then(() => {
        message.success("Link copied to clipboard!");
      })
      .catch(() => {
        message.error("Failed to copy link.");
      });
  };

  const handleCancel = () => {
    hideModal();
  };

  return (
    <Modal
      className="add-candidate-model"
      width="800px"
      visible={isModalOpen}
      onCancel={handleCancel}
      style={{ overflow: "hidden" }}
      centered
      footer={null}
    >
      <span className="absolute left-0 -top-1">{SvgIcons.roundedPattern}</span>
      <Flex gap={16} vertical className="pb-5">
        {SvgIcons.primaryFolderIcon}
        <Flex vertical>
          <span className="text-lg text-fonttext-primary font-semibold">Add External Contributors</span>
        </Flex>
      </Flex>

      <LimitedAccessForm
        hideCheckboxes={hideCheckboxes}
        selectedPool={selectedPool}
        report_id={report_id}
        onCancel={handleCancel}
      />
    </Modal>
  );
};

export default LimitedAccessModal;